import { FileUploadZone } from '@domain-group/suit-theme'

import useUppyEntityAssetUpload from '@hooks/useUppyEntityAssetUpload'

import type { SuccessResponse } from '@uppy/core'
import type { OrderItemTaskModel } from '@models/types'

interface TaskImageUploadProps {
  callbacks?: {
    afterAction?: (response: SuccessResponse) => void,
  },
  height?: string,
  orderItemTask: OrderItemTaskModel,
}

const TaskImageUpload = (props: TaskImageUploadProps) => {
  const { callbacks, height, orderItemTask } = props

  const uppy = useUppyEntityAssetUpload({
    callbacks,
    endpoint: `/order_item_tasks/${orderItemTask.id}`,
    fieldName: 'order_item_task[instruction_image]',
    requestOptions: {
      include_task_instruction_image: true,
    },
  })

  if (!uppy) return null

  return (
    <FileUploadZone height={height} uppy={uppy} />
  )
}

export default TaskImageUpload
